
//const BASE_URL = 'http://localhost:4000/api/';
//const BASE_URL = 'http://192.168.0.51:4000/api/';
const BASE_URL = 'http://' + window.location.hostname + ":4000/api/"

const ADD_URL = BASE_URL + 'add';
const SCHOOLS_URL = BASE_URL + 'schools/';
const PROFESSORS_URL = BASE_URL + 'professors/';
const TESTS_URL = BASE_URL + 'tests/';
const TEST_URL = BASE_URL + 'test/';

export { ADD_URL, SCHOOLS_URL, PROFESSORS_URL, TESTS_URL, TEST_URL };